import * as React from 'react';
import { useSelector } from 'react-redux';
import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';

import { ShowPhonesButton } from '../../components/MobileCall/ShowPhonesButton';
import { ShowPhonesModalContainer } from './ShowPhonesModal';
import { trackOpenContacts } from 'shared/analytics/call';
import { gaLabelSelector } from 'shared/selectors/newbuilding';

interface IShowPhonesContainerProps {
  builders: INewbuildingBuilder[];
  leadFactorySeller?: ISeller;
  placeType?: string;
  sellers: ISeller[];
}

export const ShowPhonesContainer: React.FC<IShowPhonesContainerProps> = ({
  builders,
  leadFactorySeller,
  placeType = 'ShowPhone',
}) => {
  const [isModalOpen, setModalOpen] = React.useState(false);

  const gaLabel = useSelector(gaLabelSelector);

  const onClick = React.useCallback(() => {
    setModalOpen(true);
    trackOpenContacts(gaLabel);
  }, [gaLabel, builders, placeType]);

  const label = leadFactorySeller ? 'Консультант' : 'Позвонить';

  return (
    <>
      <ShowPhonesButton label={label} onClick={onClick} />
      <ShowPhonesModalContainer isModalOpen={isModalOpen} closePhoneModal={() => setModalOpen(false)} />
    </>
  );
};
